import { APPROVED, REJECTED } from "../../utils/constants";
import { useGenericActionForm } from "../common/useGenericActionForm";
import { useEnquiriesActions } from "../contact_us/useEnquiries";
import { useExpenseActions } from "../expenses/useExpense";
import { useLoanApplicationActions } from "../loan_applications/useLoanApplication";
import {
  usePurchaseOrderActions,
  usePurchaseOrderBulkUpload,
} from "../purchase_orders/usePurchaseOrder";
import { useApplicationUserActions } from "../users/useApplicationUsers";
// import { useWalletDepositForm } from "../wallet_transfers/useWalletTransfers";

// handle register creation
export const actionHooks: Record<string, any> = {
  // ADD MODULE KEY HERE TO USE THE GENERAL ACTIONS
  loan_application: useLoanApplicationActions,
  // wallet_deposit: useWalletDepositForm,
  purchase_order_actions: usePurchaseOrderActions,
  bulk_purchase_order: usePurchaseOrderBulkUpload,
  application_users: useApplicationUserActions,
  expenses: useExpenseActions,
  enquiries: useEnquiriesActions,
  ...["payrolls", "loan_application_reschedule"].reduce((acc, source) => {
    return { ...acc, [source]: useGenericActionForm };
  }, {}),
};

export const customActionFields = {
  // Add custom fields here
  payrolls: [APPROVED, REJECTED],
  loan_application_reschedule: [APPROVED, REJECTED],
};
